const currencyTypes = {
   SET_CURRENCY: "SET_CURRENCY"
};
export default currencyTypes;